import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import SockJS from 'sockjs-client'
import {over} from 'stompjs'
import Api from '../../services/api'
import {MODERATOR_SERVICE_BASE_URL} from '../../services/environments'
import PageLoader from '../../components/PageLoader'
import {isAuthenticated, openNotificationInToast} from '../../utilities'
import moment from 'moment'
import {Button, Collapse} from 'antd'
import {MdClose, MdOutlineQuiz, MdOutlineSummarize} from 'react-icons/md'
import {BsCheckLg, BsGraphUpArrow, BsQuestionLg} from 'react-icons/bs'
import AdminAdView from './components/AdminAdView'
import ModeratorQuestionDrawer from './components/ModeratorQuestionDrawer'
import CloseModal from './components/CloseModal'
import {ImCalendar} from 'react-icons/im'
import {RiAdvertisementLine} from 'react-icons/ri'
import {CaretRightOutlined} from '@ant-design/icons'
import SectionSummaryDrawer from './components/SectionSummaryDrawer'
import AdminPanelConferenceSummary from './components/AdminPanelConferenceSummary'
import ErrorModal from './components/ErrorModal'
import {isMobile} from 'react-device-detect'
import AdminPanelLeaderBoard from './components/AdminPanelLeaderBoard'
import '../../assets/scss/main.scss'
import MetaDecorators from "../../components/MetaDecorators.js";

const {Panel} = Collapse

let stompClient = null
export const USER_TYPE_ADMIN = 'admin'
export const USER_TYPE_USER = 'user'
export const USER_TYPE_PROJECTOR = 'projector'

function ModeratorAdmin() {
    const {projectId} = useParams()
    const [data, setData] = useState(null)
    const [users, setUsers] = useState([])
    const [questionAttemptCount, setQuestionAttemptCount] = useState({})
    const [activeTabs, setActiveTabs] = useState(1)
    const [showingResult, setShowingResult] = useState(false)
    const [questionResult, setQuestionResult] = useState({})
    const [fullPageAdData, setFullPageAdData] = useState(null)
    const [showFullPageAd, setShowFullPageAd] = useState(false)
    const [sectionSummary, setSectionSummary] = useState({})
    const [selectedSection, setSelectedSection] = useState({})
    const [openSectionSummaryModal, setOpenSectionSummaryModal] = useState(false)
    const [questionData, setQuestionData] = useState({})
    const [openQuestionModal, setOpenQuestionModal] = useState(false)
    const [openErrorModal, setOpenErrorModal] = useState(false)
    const [showCloseModal, setShowCloseModal] = useState(false)
    const [openAdminPanelConferenceSummary, setOpenAdminPanelConferenceSummary] = useState(false)
    const [openAdminPanelLeaderBoard, setOpenAdminPanelLeaderBoard] = useState(false)

    let interval = null;

    useEffect(() => {
        return () => {
            if (stompClient) {
                stompClient.disconnect()
            }
            if (interval) {
                clearInterval(interval)
            }
        }
    }, [])

    useEffect(() => {
        const liveChat = document.getElementById("chat-widget-container");
        if (liveChat) {
            liveChat.style.display = "none";
        }
        return () => {
            if (liveChat) {
                liveChat.style.display = "unset";
            }
        };
    }, [document.getElementById("chat-widget-container")]);

    useEffect(() => {
        if (projectId && isAuthenticated()) {
            fetchActiveModeratorProjects()
            setOpenErrorModal(false)
        } else {
            setOpenErrorModal(true)
        }
    }, [projectId, isAuthenticated()])

    const fetchActiveModeratorProjects = () => {
        Api.get('v1/moderator/getIfProjectActive/' + projectId, MODERATOR_SERVICE_BASE_URL).then(response => {
            if (response.isActive) {
                getProjectDetails()
                connectToSocket()
                setOpenErrorModal(false)
            } else {
                setOpenErrorModal(true)
            }
        }).catch(error => {
            setOpenErrorModal(true)
            console.log(error)
        })
    }

    const connectToSocket = () => {
        let Sock = new SockJS(MODERATOR_SERVICE_BASE_URL + 'ws?isAdmin=true&projectId=' + projectId + '&accessToken=' + isAuthenticated())
        stompClient = over(Sock)
        stompClient.heartbeat.outgoing = 10000
        stompClient.heartbeat.incoming = 10000
        stompClient.connect({}, onConnected, onError)
        stompClient.ws.onclose = (event) => {
            if (interval) {
                clearInterval(interval)
            }
            if (event.code === 1002 || event.code === 1006) {
                console.error('Disconnected due to heartbeat failure')
                setTimeout(() => {
                    connectToSocket()
                }, 5000)
            } else {
                console.error('Disconnected from WebSocket with code:', event.code)
                setTimeout(() => {
                    connectToSocket()
                }, 5000)
            }
        }
    }

    const onConnected = () => {
        stompClient.subscribe(`/receiveAllUsers/${projectId}`, onUsersReceived)
        stompClient.subscribe(`/receiveAllQuestionsAttemptCount/${projectId}`, onQuestionAttemptCountReceived)
        stompClient.subscribe(`/receiveQuestion/${USER_TYPE_ADMIN}/${projectId}`, onQuestionReceived)
        stompClient.subscribe(`/receiveQuestionResult/${USER_TYPE_ADMIN}/${projectId}`, onResultReceived)
        stompClient.subscribe(`/receiveSectionSummary/${USER_TYPE_ADMIN}/${projectId}`, onSectionSummaryReceived)
        userJoin()
        interval = setInterval(() => {
            getUserData()
            getQuestionAttemptCounts()
        }, 5000)
    }

    const onQuestionReceived = (payload) => {
        let parsedData = JSON.parse(payload.body)
        let question = parsedData.body?.question
        if (question) {
            setShowingResult(false)
            setQuestionData(question)
            setOpenQuestionModal(true)
        }
    }

    const onResultReceived = (payload) => {
        let parsedData = JSON.parse(payload.body)
        let response = parsedData.body
        if (response) {
            setQuestionData(response.question)
            setShowingResult(true)
            setOpenQuestionModal(true)
            setQuestionResult(response)
        }
    }

    const onSectionSummaryReceived = (payload) => {
        let parsedData = JSON.parse(payload.body)
        let response = parsedData.body
        if (response) {
            setSectionSummary(response)
            setShowingResult(false)
            setOpenQuestionModal(false)
            setOpenSectionSummaryModal(true)
        }
    }

    const handleCloseQuestionDrawer = () => {
        setOpenQuestionModal(false)
        setQuestionData({})
    }

    const handleCloseSectionSummaryDrawer = () => {
        setOpenSectionSummaryModal(false)
        setSectionSummary({})
    }

    const closeFullPageAd = () => {
        setFullPageAdData(null)
        setShowFullPageAd(false)
    }

    const handleCloseAll = () => {
        handleCloseQuestionDrawer()
        handleCloseSectionSummaryDrawer()
        setShowingResult(false)
        closeFullPageAd()
        setShowCloseModal(false)
        setOpenAdminPanelConferenceSummary(false)
        setOpenAdminPanelLeaderBoard(false)
        setSelectedSection({})
    }

    const onError = (err) => {
        console.log(err)
        if (interval) {
            clearInterval(interval)
        }
        setTimeout(() => {
            connectToSocket()
        }, 5000)
    }

    const onUsersReceived = (payload) => {
        let allData = JSON.parse(payload.body)
        setUsers(allData.body?.users)
    }

    const onQuestionAttemptCountReceived = (payload) => {
        let allData = JSON.parse(payload.body)
        setQuestionAttemptCount(allData.body?.questionsAttemptCount)
    }

    const userJoin = () => {
        let payload = {
            accessToken: isAuthenticated(),
        }
        stompClient.send(`/registerAdmin/${projectId}`, {}, JSON.stringify(payload))
    }

    const getUserData = () => {
        stompClient.send(`/getAllUsers/${projectId}`, {}, '')
    }

    const getQuestionAttemptCounts = () => {
        stompClient.send(`/getAllQuestionsAttemptCount/${projectId}`, {}, '')
    }

    const getProjectDetails = () => {
        setData(null)
        Api.get(`v1/moderator/getAdminModeratorPage?moderatorProjectId=${projectId}`, MODERATOR_SERVICE_BASE_URL)
            .then((response) => {
                setData(response.moderatorPageResponse)
            })
            .catch((error) => console.log(error))
    }

    const sendOutQuestion = (question, type) => {
        let payload = {
            questionId: question.id,
        }
        stompClient.send(`/pushQuestion/${type}/${projectId}`, {}, JSON.stringify(payload))
        if (type == USER_TYPE_USER) {
            openNotificationInToast('success', 'Success!', 'Question broadcasted successfully!')
        }
        handleCloseAll()
    }

    const sendOutResult = (question, type) => {
        let payload = {
            questionId: question.id,
        }
        stompClient.send(`/pushQuestionResult/${type}/${projectId}`, {}, JSON.stringify(payload))
        if (type == USER_TYPE_USER) {
            openNotificationInToast('success', 'Success!', 'Result broadcasted successfully!')
        }
        handleCloseAll()
    }

    const sendOutSectionSummary = (section, type, e) => {
        e.stopPropagation()
        let payload = {
            sectionId: section.id,
        }
        stompClient.send(`/pushSectionSummary/${type}/${projectId}`, {}, JSON.stringify(payload))
        if (type == USER_TYPE_ADMIN) {
            setSelectedSection(section)
            setOpenSectionSummaryModal(true)
        } else {
            openNotificationInToast('success', 'Success!', 'Section Summary broadcasted successfully!')
            handleCloseAll()
        }
    }

    const openFullPageAd = (adData, e) => {
        e.stopPropagation()
        setFullPageAdData(adData)
        setShowFullPageAd(true)
    }

    const sendOutAd = () => {
        if (fullPageAdData) {
            broadcastMessage({type: 'fullPageAd', data: fullPageAdData})
            openNotificationInToast('success', 'Success!', 'Ad broadcasted successfully!')
            handleCloseAll()
        }
    }

    const broadcastMessage = (payload) => {
        stompClient.send(`/broadcast/${projectId}`, {}, JSON.stringify(payload))
    }

    const broadcastClose = () => {
        broadcastMessage({type: 'close'})
        openNotificationInToast('success', 'Success!', 'Close broadcasted successfully!')
        handleCloseAll()
    }

    const broadcastConferenceSummary = () => {
        const payload = {
            accessToken: isAuthenticated(),
        }
        stompClient.send(`/computeClosestMatch/${projectId}`, {}, JSON.stringify(payload))
        openNotificationInToast('success', 'Success!', 'Conference Summary broadcasted successfully!')
        handleCloseAll()
    }

    const broadcastLeaderBoard = () => {
        const payload = {
            accessToken: isAuthenticated(),
        }
        stompClient.send(`/generateLeaderboard/${projectId}`, {}, JSON.stringify(payload))
        openNotificationInToast('success', 'Success!', 'Leader Board broadcasted successfully!')
        handleCloseAll()
    }

    return data && data.id ? (
        <div className='flex fd-column'>
            <MetaDecorators/>
            <div
                className='flex sm-fd-column items-center jc-space-between height-fit-content pt-32 pb-16 pl-32 pr-32 sm-pt-16 sm-pl-16 sm-pr-16'
                style={{background: 'linear-gradient(180deg, rgba(237,62,114,0.25) 0%, rgba(137,113,33,0) 100%)'}}>
                <img className='animated fadeIn-up rounded-12 box-shadow' src={data.taggedProjectThumbnail}
                     width={isMobile ? '100%' : '300px'} height={'100%'} alt={data.taggedProjectName}/>
                <div className='flex fd-column jc-center items-flex-end sm-items-center'>
                    <div className='font-size-42 font-bold-700 font-color-pink kaushan-script-font'>Hello There!</div>
                    <div className='font-size-28 font-bold-700 font-color-2 mt-8 text-right sm-text-center'>You are here
                        to moderate
                        this {data.productType == 3 ? 'Conference' : data.productType == 2 ? 'OC Original' : 'CME'}</div>
                    <Button type='primary' shape='circle' className='flex items-center rounded-12 p-16 mt-16'
                            onClick={() => setOpenAdminPanelConferenceSummary(true)}>
                        <MdOutlineSummarize className='font-color-white font-size-18 mr-8'/>
                        Final {data.productType == 3 ? 'Conference' : data.productType == 2 ? 'OC Original' : 'CME'} Summary
                    </Button>
                    <Button type='primary' shape='circle' className='flex items-center rounded-12 p-16 mt-16'
                            onClick={() => setOpenAdminPanelLeaderBoard(true)}>
                        <MdOutlineSummarize className='font-color-white font-size-18 mr-8'/>
                        Show Leader Board
                    </Button>
                </div>
            </div>
            <div
                className='font-size-18 font-bold-700 font-color-2 fadeIn-up animated flex items-center sm-jc-center ml-32 mr-32 sm-ml-16 sm-mr-16'>
                <ImCalendar className='mr-8'/>
                Happening on : {moment(new Date(data.launchDate)).format('Do MMMM, yyyy')}
            </div>
            <div className='p-32 sm-p-16'>
                <div className='tabs-container fd-row items-center flex'>
                    <div key={0}
                         className={`font-size-24 sm-font-size-16 font-bold-700 font-color-2 p-16 cursor-pointer ${activeTabs === 1 ? 'tabs-active' : ''}`}
                         onClick={() => setActiveTabs(1)}>
                        All Questions
                    </div>
                    <div key={1}
                         className={`font-size-24 sm-font-size-16 font-bold-700 font-color-2 p-16 cursor-pointer ${activeTabs === 2 ? 'tabs-active' : ''}`}
                         onClick={() => setActiveTabs(2)}>
                        List of all users (<span
                        className='min-width-16 min-height-16 rounded-full blinking-text bg-green-100 inline-block mr-5 ml-5'></span>Active
                        - {users && users.filter((user) => user.userStatus == 'ACTIVE').length} out of{' '}
                        {users && users.length})
                    </div>
                </div>
                <Collapse bordered={false} defaultActiveKey={[0]}
                          expandIcon={({isActive}) => <CaretRightOutlined style={{fontSize: 20}}
                                                                          rotate={isActive ? 90 : 0}/>}
                          className='collapse-moderator mt-20'>
                    {activeTabs === 1 &&
                        data.moderatorSectionResponses &&
                        data.moderatorSectionResponses.map((section, idx1) => {
                            return (
                                <Panel
                                    header={
                                        <div
                                            className='uppercase width-full font-bold-600 font-color-2 font-size-16 fadeIn-up flex sm-fd-column jc-space-between items-center sm-items-flex-start'>
                                            <div>{section.name}</div>
                                            <div className='flex items-center sm-mt-8'>
                                                {section.advertisement && section.advertisement.adId ? (
                                                    <Button onClick={(e) => openFullPageAd(section.advertisement, e)}
                                                            type='primary' shape='circle'
                                                            className='flex items-center rounded-12 p-16'>
                                                        <RiAdvertisementLine
                                                            className='font-color-white font-size-18 mr-8'/> Advertisement
                                                    </Button>
                                                ) : (
                                                    ''
                                                )}
                                                <Button
                                                    onClick={(e) => sendOutSectionSummary(section, USER_TYPE_ADMIN, e)}
                                                    type='primary' shape='circle'
                                                    className='flex items-center rounded-12 p-16 ml-16 sm-ml-4'>
                                                    <MdOutlineSummarize
                                                        className='font-color-white font-size-18 mr-8'/> Section Summary
                                                </Button>
                                            </div>
                                        </div>
                                    }
                                    key={idx1}
                                >
                                    {section.sectionQuestionResponses &&
                                        section.sectionQuestionResponses.map((question, index) => {
                                            return (
                                                <div>
                                                    <div className='flex items-flex-start p-16 sm-p-0 fadeIn-up'>
                                                        <div className='flex items-center'>
                                                            <div
                                                                className={`shadowed rounded-full min-width-34 min-height-34 flex jc-center items-center ${
                                                                    questionAttemptCount && questionAttemptCount[question.id] ? 'bg-green-100 font-color-white' : 'font-color-1 border-2 border-pink-100'
                                                                } font-bold-600 font-size-16`}
                                                            >
                                                                {questionAttemptCount && questionAttemptCount[question.id] ?
                                                                    <BsCheckLg className='font-size-20'/> :
                                                                    <BsQuestionLg className='font-size-20'/>}
                                                            </div>
                                                        </div>
                                                        <div className='flex fd-column jc-center ml-16 sm-ml-8'>
                                                            <div className='flex'>
                                                                <Button
                                                                    onClick={() => sendOutQuestion(question, USER_TYPE_ADMIN)}
                                                                    size={isMobile ? 'small' : 'middle'} type='primary'
                                                                    className='flex items-center rounded-12 p-16'>
                                                                    <MdOutlineQuiz
                                                                        className='font-color-white font-size-18 mr-8'/> Question
                                                                </Button>
                                                                <Button
                                                                    onClick={() => sendOutResult(question, USER_TYPE_ADMIN)}
                                                                    type='primary' shape='circle'
                                                                    className='flex items-center rounded-12 p-16 ml-16 sm-ml-4'>
                                                                    <BsGraphUpArrow
                                                                        className='font-color-white font-size-18 mr-8'/> Question
                                                                    Result
                                                                </Button>
                                                                <Button onClick={() => setShowCloseModal(true)}
                                                                        type='primary' danger shape='circle'
                                                                        className='flex items-center rounded-12 p-16 ml-16 sm-ml-4'>
                                                                    <MdClose
                                                                        className='font-color-white font-size-18 mr-8'/> Close
                                                                    Pop Up
                                                                </Button>
                                                            </div>
                                                            <div className='flex fd-column'>
                                                                <div className='flex mt-16'>
                                                                    <span
                                                                        className='mr-8 font-bold-600 flex-shrink-0'>Q{index + 1}.</span>
                                                                    <span className='lines-2 font-size-16 font-color-2'
                                                                          dangerouslySetInnerHTML={{__html: question.name}}/>
                                                                </div>
                                                                {questionAttemptCount && questionAttemptCount[question.id] ? (
                                                                    <div
                                                                        className='mt-8 font-bold-600 font-color-pink'>Total
                                                                        Users Responded
                                                                        : {questionAttemptCount[question.id].count}</div>
                                                                ) : (
                                                                    <div
                                                                        className='mt-8 font-bold-600 font-color-blue'>Question
                                                                        not attempted</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                </Panel>
                            )
                        })}
                </Collapse>
                {activeTabs === 2 && users && users.length > 0 && (
                    <table width='100%' border='1px' border-spacing='8px' className='mt-20'
                           style={{borderColor: '#ddd'}}>
                        <tr className='bg-pink-15'>
                            <td className='p-8'>
                                <b>ID</b>
                            </td>
                            <td className='p-8'>
                                <b>User Name</b>
                            </td>
                            <td className='p-8'>
                                <b>Status</b>
                            </td>
                        </tr>
                        {users.map((user) => {
                            return (
                                <tr>
                                    <td className='p-8'>{user.id}</td>
                                    <td className='p-8'>{user.name}</td>
                                    <td className='p-8'>
                                        <span
                                            className={`uppercase pt-4 pb-4 pl-8 pr-8 rounded-50 bg-${user.userStatus == 'ACTIVE' ? 'pink' : 'blue'}-100 font-bold-600 font-size-12 font-color-white`}>{user.userStatus}</span>
                                    </td>
                                </tr>
                            )
                        })}
                    </table>
                )}
            </div>
            {showFullPageAd ? <AdminAdView advData={fullPageAdData} open={showFullPageAd} setOpen={closeFullPageAd}
                                           sendOutAd={sendOutAd}/> : ''}
            <CloseModal open={showCloseModal} setOpen={setShowCloseModal} broadcastClose={broadcastClose}/>
            <ModeratorQuestionDrawer
                visible={openQuestionModal}
                setVisible={handleCloseAll}
                questionData={questionData}
                showingResult={showingResult}
                selectedData={{}}
                setSelectedData={() => {
                }}
                questionResult={questionResult}
                isAdmin={true}
                sendOutQuestion={() => (showingResult ? sendOutResult(questionData, USER_TYPE_USER) : sendOutQuestion(questionData, USER_TYPE_USER))}
            />
            <SectionSummaryDrawer open={openSectionSummaryModal} setOpen={setOpenSectionSummaryModal}
                                  sectionSummary={sectionSummary}
                                  sendOutSectionSummary={(e) => sendOutSectionSummary(selectedSection, USER_TYPE_USER, e)}
                                  isAdmin={true}/>
            <AdminPanelConferenceSummary open={openAdminPanelConferenceSummary}
                                         setOpen={setOpenAdminPanelConferenceSummary}
                                         broadcastConferenceSummary={broadcastConferenceSummary}/>
            <AdminPanelLeaderBoard open={openAdminPanelLeaderBoard} setOpen={setOpenAdminPanelLeaderBoard}
                                   broadcastLeaderBoard={broadcastLeaderBoard}/>
            {/* <div className='dot-items font-size-14 font-color-2 mt-8 animated fadeIn-up' style={{ animationDelay: `0.3s` }}>
            {data.specialities ? data.specialities.map((spec) => {
                return <span>{spec.name}</span>;
            }) : ""}
            {data.duration ? <span>{convertToHoursAndMinutes(data.duration)}</span> : ""}
        </div>
        <div className='fadeIn-up animated' style={{ animationDelay: `0.45s` }}><ReadMoreLess charLimit={400} className='font-size-16 mt-8' content={data.taggedProjectDescription} /></div>
        {data.experts && data.experts.length > 0 ? <div className='fadeIn-up animated' style={{ animationDelay: `0.6s` }}><ExpertsSwiper speakers={data.experts} /></div> : ""}
        {data.organizations && data.organizations.length > 0 ? <div className='fadeIn-up animated' style={{ animationDelay: `0.75s` }}><Organizations data={data.organizations} noAction={true} className="mt-16" titleClass="font-size-16 sm-font-size-12" /></div> : ""} */}
        </div>
    ) : openErrorModal ? <ErrorModal open={openErrorModal} setOpen={setOpenErrorModal}/> : <PageLoader loading={true}/>
}

export default ModeratorAdmin
